var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.443,
    height: 31.884,
    viewBox: "0 0 31.443 31.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(1 0.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M2.9,9.707l8.869-8.235a1.082,1.082,0,0,1,1.472,0l8.869,8.235",
    transform: "translate(2.214)",
    fill: "none",
    stroke: "#3c424a",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M7.341,2V21.9",
    transform: "translate(7.38 0.952)",
    fill: "none",
    stroke: "#3c424a",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M1,10.512v3.219a4.327,4.327,0,0,0,4.328,4.328H24.115a4.327,4.327,0,0,0,4.328-4.328V10.512",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#3c424a",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.1337532a48088a9063f596f7678e3b6f.svg";
export { ForwardRef as ReactComponent };